import { forwardRef, type Ref, type SVGProps } from "react";
const IconMLSOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m7.78 4.85-2.5-1.67a.52.52 0 0 0-.56 0l-2.5 1.67a.5.5 0 0 0-.22.42V9.5a.5.5 0 0 0 .5.5H4V7h2v3h1.5a.5.5 0 0 0 .5-.5V5.27a.5.5 0 0 0-.22-.42M28.88 8H14.12A1.07 1.07 0 0 1 13 7a1.07 1.07 0 0 1 1.12-1h14.76A1.07 1.07 0 0 1 30 7a1.07 1.07 0 0 1-1.12 1m-21.1 5.85-2.5-1.67a.52.52 0 0 0-.56 0l-2.5 1.67a.5.5 0 0 0-.22.42v4.23a.5.5 0 0 0 .5.5H4v-3h2v3h1.5a.5.5 0 0 0 .5-.5v-4.23a.5.5 0 0 0-.22-.42M28.88 17H14.12a1 1 0 1 1 0-2h14.76a1 1 0 1 1 0 2m-21.1 5.85-2.5-1.67a.52.52 0 0 0-.56 0l-2.5 1.67a.5.5 0 0 0-.22.42v4.23a.5.5 0 0 0 .5.5H4v-3h2v3h1.5a.5.5 0 0 0 .5-.5v-4.23a.5.5 0 0 0-.22-.42M28.88 26H14.12a1 1 0 1 1 0-2h14.76a1 1 0 1 1 0 2" />
  </svg>
);
const ForwardRef = forwardRef(IconMLSOutlineSVG);
ForwardRef.displayName = "IconMLSOutline";
export { ForwardRef as IconMLSOutline };
